import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../shared.functions';
import { Cuenta, SaveCuentaDto, SearchCuentaRequest } from '../model';

@Injectable({
  providedIn: 'root'
})
export class CuentaService extends CrudService<Cuenta, number, SaveCuentaDto, SearchCuentaRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'cuenta', sharedFunctions);
  }
}
